import { gql } from '@apollo/client'

export const APPROVE_VACCINATION = gql`
  mutation ApproveVaccination($inputData: ApproveVaccinationInput!) {
    approveVaccination(inputData: $inputData) {
      id
    }
  }
`
